(function () {
  'use strict';

  angular
    .module('notificationsLog')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('notificationsLog', {
        url: '/notifications-log',
        views: {
          'notificationsLogView' : {
            templateUrl: 'notifications-log/views/notifications-log.tpl.html',
            controller: 'NotificationsLogCtrl',
            controllerAs: 'notificationsLog'
          }
        }
      });
  }
}());
